import { ModalView, useModalView } from '@/design-system/components/modal';
import { NativeModalView } from '@/design-system/components/modal/nativeModal/NativeModalView';
import { useNativeModalView } from '@/design-system/components/modal/nativeModal/useNativeModalView';
import { LayoutContext } from 'contexts/LayoutContext';
import { useContext } from 'react';
import { UtxAppEmbed } from '@/design-system/components/utxAppEmbedCallback/utxAppEmbedCallback';

interface ModalContainerViewProps {
  dimensions: {
    height: number;
    width: number;
  };
  nativeFlag?: boolean;
}

export const ModalContainerView: React.FC<ModalContainerViewProps> = ({ dimensions, children, nativeFlag = { default: true } }) => {
  const layout = useContext(LayoutContext);

  if (layout.isMobile) {
    if (nativeFlag) {
      const { animatedStyle, handleBack } = useNativeModalView({});
      return (
        <NativeModalView animatedStyle={animatedStyle} onBack={handleBack} showHeader={false}>
          <UtxAppEmbed>{children}</UtxAppEmbed>
        </NativeModalView>
      );
    } else {
      return <UtxAppEmbed>{children}</UtxAppEmbed>;
    }
  }

  const modal = useModalView({ dimensions });

  return <ModalView {...modal}>{children}</ModalView>;
};
